<div *ngIf="editUser">
  <div class="fx-layout-column" *ngIf="user.isGuest">
    <h3>Guest Information</h3>
    <table class="guest-user">
      <tr>
        <th>Email Address:</th>
        <td>{{ user.email }}</td>
      </tr>
      <tr>
        <th>Full Name:</th>
        <td>{{ user.fullname }}</td>
      </tr>
      <tr>
        <th>Phone Number:</th>
        <td>{{ user.phonenumber }}</td>
      </tr>
    </table>
    <div class="action-buttons fx-layout-row fx-align--x-space-between">
      <button mat-flat-button color="primary" (click)="popChangePassword($event)">Register Account</button>
      <button mat-flat-button color="secondary" *ngIf="user.impersonating" (click)="signOut()">Sign Out</button>
    </div>
  </div>
  <form *ngIf="!user.isGuest && !editableInfo">
    <h3>Personal Information</h3>
    <div class="fx-layout-row fx-gap--8px">
      <div>
        <a mat-outline-button color="secondary" *ngIf="!editableInfo" class="icon edit"
               (click)="editableInfo = !editableInfo">
          <mat-icon svgIcon="pencil-circle"></mat-icon>
        </a>
      </div>
      <div class="fx-layout-column fx-gap--16px">
        <div>
          <div>{{editUser.email}}</div>
          <div>{{editUser.fullname}}</div>
          <div>{{editUser.phonenumber}}</div>
        </div>
        <div class="fx-layout-row fx-gap--16px">
          <button type="submit" mat-flat-button color="primary" *ngIf="editableInfo"
                  (click)="editableInfo = !editableInfo">Edit Personal Information</button>
          <button mat-flat-button color="primary" (click)="popChangePassword($event)">Change Password</button>
          <button mat-flat-button color="secondary" (click)="signOut()">Sign Out</button>
        </div>
      </div>
    </div>
  </form>
  <form class="fx-layout-column" *ngIf="!user.isGuest && editableInfo">
    <h3>Personal Information</h3>
    <mat-form-field>
      <mat-label>email address</mat-label>
      <input matInput type="text" name="email" required
        [(ngModel)]="editUser.email">
    </mat-form-field>
    <mat-form-field *ngIf="editUser.email !== user.email">
      <mat-label>confirm email address</mat-label>
      <input matInput type="text" name="email2" required
        [(ngModel)]="editUser.email2">
    </mat-form-field>
    <mat-form-field *ngIf="editUser.email !== user.email">
      <mat-label>re-enter password</mat-label>
      <mbnm-password-revealer>
        <input matInput type="password" name="password" required
               [(ngModel)]="editUser.password">
      </mbnm-password-revealer>
    </mat-form-field>
    <mat-form-field>
      <mat-label>full name</mat-label>
      <input matInput type="text" name="fullname" required
        [(ngModel)]="editUser.fullname">
    </mat-form-field>
    <mat-form-field>
      <mat-label>phone number</mat-label>
      <input matInput type="text" name="phonenumber" required
        [(ngModel)]="editUser.phonenumber">
    </mat-form-field>
    <mat-checkbox name="newsletterEmail" [(ngModel)]="editUser.newsletterEmailState"
                  [disabled]="editUser.subscriptions.newsletterEmailStatus === 'UNKNOWN'">
      <ng-container [ngSwitch]="editUser.subscriptions.newsletterEmailStatus">
        <ng-container *ngSwitchCase="'UNKNOWN'">
          Unable to update at at this time.
        </ng-container>
        <ng-container *ngSwitchDefault>
          Email  me news & promotions
        </ng-container>
      </ng-container>
    </mat-checkbox>
    <!--
    <mat-checkbox name="smsMarketing" [(ngModel)]="editUser.smsMarketingState"
                  (ngModelChange)="showSMSDisclaimer($event)"
                  [disabled]="editUser.subscriptions.smsMarketingStatus === 'INELIGIBLE' || editUser.subscriptions.smsMarketingStatus === 'UNKNOWN'">
      <ng-container [ngSwitch]="editUser.subscriptions.smsMarketingStatus">
        <ng-container *ngSwitchCase="'INELIGIBLE'">
          Complete (or restart) your SMS subscriptions via text.
          Check your messages for more info.
        </ng-container>
        <ng-container *ngSwitchCase="'UNKNOWN'">
          Unable to update at at this time.
        </ng-container>
        <ng-container *ngSwitchDefault>
          Text me news & promotions
        </ng-container>
      </ng-container>
    </mat-checkbox>
    -->
    <div class="fx-layout-row fx-gap--16px">
      <button type="submit" mat-flat-button color="primary" (click)="saveUserInfo($event)">Save Changes</button>
      <button mat-flat-button color="secondary" (click)="resetUserInfo()">Cancel</button>
    </div>
  </form>
</div>
